export default __webpack_public_path__ + "static/media/Link.91858ef6.svg";